import { graphql } from "../../../services/wp.api.service";

const query = `
	mutation UserRegistration(
		$username: String = "", 
		$email: String = "",
		$firstName: String = "",
		$lastName: String = "",
		$password: String = "",
		$terms: [String] = []
	) {
		registerUser(
		input: {
			username: $username, 
			firstName: $firstName, 
			email: $email, 
			lastName: $lastName, 
			password: $password,
			terms: $terms
		}
		) {
			user {
				email
				firstName
				lastName
				jwtRefreshToken
				jwtAuthToken
				emailVerified
			}
		}
	}
`;

const registerUserQuery = (useMutation, options) => useMutation(
	"registerNewUser",
	(variables) => graphql({
		query,
		variables
	}, true),
	options
);

export default registerUserQuery;
